const bestsellerSwiper = new Swiper(".bestsellerSwiper", {
	spaceBetween: 2,
	slidesPerGroup: 1,
	loop: true,
	scrollbar: {
		el: ".bestsellerScrollbar",
	},
	autoplay: {
		delay: 4000,
	},
	breakpoints: {
		320: {
			slidesPerView: 1,
		},
		376: {
			slidesPerView: 2,
		},
		993: {
			slidesPerView: 3,
		}
	},
})

const reviewsSwiper = new Swiper(".reviewsSwiper", {
	loop: true,
	slidesPerGroup: 1,
	spaceBetween: 50,
	navigation: {
		nextEl: ".reviewsSwiper-button-next",
		prevEl: ".reviewsSwiper-button-prev",
	},
	autoplay: {
		delay: 4000,
	},
	breakpoints: {
		320: {
			slidesPerView: 1,
		},
		769: {
			slidesPerView: 2,
		},
		1201: {
			slidesPerView: 3,
			spaceBetween: 82,
		}
	},
})

const followSwiper = new Swiper(".followSwiper", {
	spaceBetween: 2,
	slidesPerView: 'auto',
	loop: true,
	scrollbar: {
		el: ".followScrollbar",
	},
})

